module.exports = __webpack_public_path__ + "static/media/chart2.530f856c.gif";